define('helperLayout-setSvgTexts',['helperContent-componentObject', 'lodash'], function(componentObject, _) {
    'use strict';

    var getSvgTextAttributes = function(textEl, viewModel){
        var id = textEl.attr('data-text-id'),
            attributes = {},
            components = viewModel.training.getComponentsByKind('SVGWithText');

        if(components && components.length > 0) {
            components.forEach(function (comp) {
                var componentContent = componentObject.getComponentsByParamValue(comp.content.items, 'id', id)[0];
                if(componentContent){
                    delete componentContent.index;
                    delete componentContent.id;
                    if(componentContent.weight === "700") componentContent.weight = "600";      // win7 and Safari support
                    componentContent = _.omit(componentContent, _.isNull);
                    attributes = componentContent;
                }
            });
        }
        return attributes;
    },
    setSvgTexts = function($svgSelection, viewModel){

        $svgSelection.each(function (svg) {
            var svgEl = window.Snap($svgSelection[svg]);
            var textEls = svgEl.selectAll('[data-text-id]');
            textEls.forEach(function (textEl) {
                textEl.setText(viewModel, getSvgTextAttributes(textEl, viewModel));
            });
        });
    };

    return setSvgTexts;
});

